"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _reactIntl = require("react-intl");
var _Locations = _interopRequireDefault(require("../locations/Locations"));
var _ServiceAreas = _interopRequireDefault(require("../ServiceAreas"));
var _ProgramAcceptance = _interopRequireDefault(require("./ProgramAcceptance"));
var _ProgramDescription = _interopRequireDefault(require("./ProgramDescription"));
var _ProgramEligibility = _interopRequireDefault(require("./ProgramEligibility"));
var _ProgramUsersInfo = _interopRequireDefault(require("./ProgramUsersInfo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProgramDetailsV2 = function ProgramDetailsV2(props) {
  var className = props.className,
    clickableAddress = props.clickableAddress,
    feeScheduleProgramIconDetails = props.feeScheduleProgramIconDetails,
    initiallyCollapsed = props.initiallyCollapsed,
    isFeeScheduleProgram = props.isFeeScheduleProgram,
    openLink = props.openLink,
    originLatLng = props.originLatLng,
    _props$program = props.program,
    locations = _props$program.locations,
    service_areas = _props$program.service_areas,
    name = _props$program.name,
    receiving_referrals = _props$program.receiving_referrals,
    status = _props$program.status,
    is_active = _props$program.is_active,
    program = props.program,
    rightHeaderComponent = props.rightHeaderComponent,
    showProgramUsersInfo = props.showProgramUsersInfo,
    intlProvider = props.intlProvider,
    showReferralStatus = props.showReferralStatus;
  var RightHeaderComponent = rightHeaderComponent;
  var serviceAreas = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !(0, _lodash.isEmpty)(service_areas) && /*#__PURE__*/_react["default"].createElement(_ServiceAreas["default"], {
    className: "program-details__section",
    service_areas: service_areas,
    intlProvider: intlProvider
  }));
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages
  }, /*#__PURE__*/_react["default"].createElement(_ui.Card, {
    className: (0, _classnames["default"])('program-details', className)
  }, /*#__PURE__*/_react["default"].createElement(_ui.CardHeader, {
    className: "program-details__header ".concat(className),
    headerIconDetails: feeScheduleProgramIconDetails,
    showHeaderIcon: isFeeScheduleProgram,
    title: name,
    subtitle: (0, _lodash.get)(program, 'name_untranslated', '')
  }, showReferralStatus && /*#__PURE__*/_react["default"].createElement(_ProgramAcceptance["default"], {
    receiving_referrals: receiving_referrals,
    status: status,
    hide_referrals: true,
    is_active: is_active
  }), rightHeaderComponent && /*#__PURE__*/_react["default"].createElement(RightHeaderComponent, null)), /*#__PURE__*/_react["default"].createElement(_ui.CardText, null, initiallyCollapsed ? /*#__PURE__*/_react["default"].createElement(_ui.MoreOrLess, null, /*#__PURE__*/_react["default"].createElement(_ProgramUsersInfo["default"], {
    program: program,
    showProgramUsersInfo: showProgramUsersInfo
  }), /*#__PURE__*/_react["default"].createElement(_ProgramDescription["default"], {
    className: "program-details__section",
    openLink: openLink,
    program: program
  }), !(0, _lodash.isEmpty)(locations) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_Locations["default"], {
    className: "program-details__section",
    clickableAddress: clickableAddress,
    locations: locations,
    originLatLng: originLatLng,
    intlProvider: intlProvider
  }), (!(0, _lodash.isEmpty)(locations) || !(0, _lodash.isEmpty)(service_areas)) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), serviceAreas, !(0, _lodash.isEmpty)(service_areas) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_ProgramEligibility["default"], {
    className: "program-details__section",
    program: program
  })) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ProgramUsersInfo["default"], {
    program: program,
    showProgramUsersInfo: showProgramUsersInfo
  }), /*#__PURE__*/_react["default"].createElement(_ProgramDescription["default"], {
    className: "program-details__section",
    openLink: openLink,
    program: program,
    showMore: true
  }), !(0, _lodash.isEmpty)(locations) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_Locations["default"], {
    className: "program-details__section",
    clickableAddress: clickableAddress,
    locations: locations,
    originLatLng: originLatLng,
    intlProvider: intlProvider,
    showMore: true
  }), (!(0, _lodash.isEmpty)(locations) || !(0, _lodash.isEmpty)(service_areas)) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), serviceAreas, !(0, _lodash.isEmpty)(service_areas) && /*#__PURE__*/_react["default"].createElement(_ui.Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/_react["default"].createElement(_ProgramEligibility["default"], {
    className: "program-details__section",
    program: program,
    showMore: true
  })))));
};
ProgramDetailsV2.propTypes = {
  className: _propTypes["default"].string,
  clickableAddress: _propTypes["default"].bool,
  initiallyCollapsed: _propTypes["default"].bool,
  openLink: _propTypes["default"].func,
  originLatLng: _propTypes["default"].array,
  isFeeScheduleProgram: _propTypes["default"].bool,
  feeScheduleProgramIconDetails: _propTypes["default"].object,
  program: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    receiving_referrals: _propTypes["default"].bool,
    status: _propTypes["default"].string,
    is_active: _propTypes["default"].bool,
    locations: _propTypes["default"].array,
    service_areas: _propTypes["default"].array,
    eligibility_text: _propTypes["default"].string
  }).isRequired,
  /**
   * Property to pass a component that will render in the header.
   * This feature is used to render an edit program link in the upper right.
   */
  rightHeaderComponent: _propTypes["default"].func,
  showProgramUsersInfo: _propTypes["default"].bool,
  intlProvider: _propTypes["default"].shape({
    locale: _propTypes["default"].string,
    messages: _propTypes["default"].array
  }),
  showReferralStatus: _propTypes["default"].bool
};
ProgramDetailsV2.defaultProps = {
  className: '',
  clickableAddress: false,
  feeScheduleProgramIconDetails: {},
  initiallyCollapsed: true,
  isFeeScheduleProgram: false,
  openLink: window.open,
  originLatLng: [],
  program: {},
  rightHeaderComponent: null,
  showProgramUsersInfo: false,
  intlProvider: {
    locale: 'en',
    messages: []
  },
  showReferralStatus: true
};
var _default = exports["default"] = ProgramDetailsV2;